import { withDatasourceCheck, RichText } from "@sitecore-jss/sitecore-jss-nextjs";
import { ComponentProps } from "lib/component-props";
import Link from "next/link";
import Image from "next/image";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useEffect, useState } from "react";

type FooterNavigationProps = ComponentProps & {
  fields: any;
  locale: string;
  lang: string;
};

const RenderLinks = (linksArray: any) => {
  return linksArray.map((linkData: any, index: number) => {
    return (
      <div key={index} className="font-effra">
        {linkData?.fields?.LinkUrl?.value?.href ? (
          <>
            {linkData?.fields?.LinkUrl?.value?.linktype == "external" ? (
              <div
                className={` text-[#F2F2F2] lg:text-[16px] text-[8px] ${
                  linkData?.fields?.TextBold?.value == true && " font-semibold"
                } ${linkData?.fields?.Underline?.value == true && "underline underline-offset-4"} `}
              >
                <Link
                  passHref
                  href={linkData?.fields?.LinkUrl?.value?.href.replace(
                    process?.env?.NEXT_PUBLIC_SITECORE_API_HOST,
                    ""
                  )}
                >
                  <a
                    className="text-[#F2F2F2] lg:text-[16px] text-[8px]"
                    target={linkData?.fields?.LinkUrl?.value?.target}
                  >
                    {linkData?.fields?.LinkText?.value}
                  </a>
                </Link>
              </div>
            ) : linkData?.fields?.LinkUrl?.value?.linktype == "internal" ? (
              <div
                className={` text-[#F2F2F2] lg:text-[16px] text-[8px] ${
                  linkData?.fields?.TextBold?.value == true && " font-semibold"
                } ${linkData?.fields?.Underline?.value == true && "underline underline-offset-4"} `}
              >
                <Link
                  passHref
                  href={linkData?.fields?.LinkUrl?.value?.href.replace(
                    process?.env?.NEXT_PUBLIC_SITECORE_API_HOST,
                    ""
                  )}
                >
                  <a
                    className="text-[#F2F2F2] lg:text-[16px] text-[8px]"
                    target={linkData?.fields?.LinkUrl?.value?.target}
                  >
                    {linkData?.fields?.LinkText?.value}
                  </a>
                </Link>
              </div>
            ) : (
              <></>
            )}
          </>
        ) : linkData?.fields?.LinkText?.value ? (
          <div
            className={` text-[#F2F2F2] lg:text-[16px] text-[8px] ${
              linkData?.fields?.TextBold?.value == true && " font-semibold"
            } ${linkData?.fields?.Underline?.value == true && "underline underline-offset-4"} `}
          >
            {" "}
            {linkData?.fields?.LinkText?.value}
          </div>
        ) : (
          ""
        )}
      </div>
    );
  });
};

const FooterNavigation = (props: FooterNavigationProps): JSX.Element => {
  const [Disabled, setDisabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [SubscriptionText, setSubscriptionText] = useState("");
  const SubscribeForm = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email(props?.fields?.EmailInvalidText?.value)
        .required(props?.fields?.EmailRequiredText?.value),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      try {
        setDisabled(true);
        const res = await axios.post(
          `${process.env.NEXT_PUBLIC_SITECORE_REST}/api/Subscription/moc/Submit`,
          {
            Email: values.email,
            Language: props?.locale,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        SubscribeForm.resetForm();
        setDisabled(false);
        setLoading(false);
        setSubscriptionText(
          res?.data == "You are already subscribed!"
            ? "You are already subscribed!"
            : props?.fields?.SubscriptionSuccess?.value
        );
      } catch (error) {
        setLoading(false);
        setDisabled(false);
        setSubscriptionText(props?.fields?.SubscriptionError?.value);
      }
    },
  });
  useEffect(() => {
    setSubscriptionText("");
  }, [props?.locale]);
  return (
    <div className={` ${props?.locale == "ar" ? "rtl" : ""} bg-[#0F2837] w-full py-12 `}>
      <div className="responsive  ">
        {/* Icon seprate from the bottom section for Large display */}
        <div className="w-full mb-5 lg:block hidden">
          <Link href={"/"}>
            <Image
              className="cursor-pointer"
              src={props?.fields?.Logo?.value?.src}
              alt={props?.fields?.Logo?.value?.alt || "img"}
              width={125}
              height={70}
              layout="fixed"
            />
          </Link>
        </div>

        {/* Dividing section into 3 parts  */}
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {/* //Section 1 */}
          <div className="col-span-1 flex flex-col gap-2">
            <span className="lg:hidden inline-block ">
              {/* Icon seprate from the bottom section for small display */}
              <Link href={"/"}>
                <Image
                  className="cursor-pointer"
                  src={props?.fields?.Logo?.value?.src}
                  alt={props?.fields?.Logo?.value?.alt || "img"}
                  width={63}
                  height={40}
                  layout="fixed"
                />
              </Link>
            </span>
            <RichText
              className={`text-[#F2F2F2] lg:[&>p]:leading-6 [&>p]:leading-3 lg:[&>span]:leading-6 [&>span]:leading-3 lg:leading-6 leading-3      lg:[&>p]:text-[16px] [&>p]:text-[8px] lg:[&>span]:text-[16px] [&>span]:text-[8px] lg:text-[16px] text-[8px]   `}
              field={props?.fields?.Address}
            />
            {props?.fields?.SectionOneLinks?.length > 0 &&
              RenderLinks(props?.fields?.SectionOneLinks)}
          </div>

          {/* //Section 2 */}
          <div className="col-span-1 grid grid-cols-2">
            <div className="col-span-1 flex flex-col lg:gap-5 gap-3">
              {props?.fields?.SectionTwoLinks?.length > 0 &&
                RenderLinks(props?.fields?.SectionTwoLinks)}
            </div>
            <div className="col-span-1 flex flex-col lg:gap-5 gap-3">
              {props?.fields?.SectionThreeLinks?.length > 0 &&
                RenderLinks(props?.fields?.SectionThreeLinks)}
            </div>
            {/*
            //Section 3 form combined with section 2 for mobile Design */}
            <div className="lg:hidden col-span-2 mt-2 ">
              <h2 className="text-[#F2F2F2] lg:text-[18px] text-[9px] font-semibold">
                {props?.fields?.Title?.value}
              </h2>
              <div className="disclaimer w-full  ">
                <p className="text-[#a6a5a5] text-[7px] md:text-[16px]">
                  {props?.fields?.Disclaimer?.value}
                </p>
              </div>
              <form className="w-full" onSubmit={SubscribeForm.handleSubmit}>
                <div className="border-[#F2F2F2] border p-1 w-full flex lg:mt-4 mt-2">
                  <input
                    disabled={Disabled}
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="off"
                    onChange={SubscribeForm.handleChange}
                    onBlur={SubscribeForm.handleBlur}
                    value={SubscribeForm.values.email}
                    placeholder={props?.fields?.EmailPlaceholder?.value}
                    className={`bg-transparent text-white  ${
                      props?.locale == "ar" ? "lg:mr-3 mr-1" : "lg:ml-3 ml-1"
                    } text-[8px]   lg:text-[16px] w-full`}
                  />

                  <button
                    disabled={Disabled}
                    type="submit"
                    className="w-fit h-full lg:text-[16px] text-[8px] text-[142836] bg-white text-brand-50 lg:p-3 p-1"
                  >
                    {!loading && <span>{props?.fields?.SubmitBtnText?.value}</span>}
                    {loading && (
                      <svg
                        aria-hidden="true"
                        className="inline w-4 h-4 animate-spin fill-brand-800"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="currentColor"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentFill"
                        />
                      </svg>
                    )}
                  </button>
                </div>
                {SubscribeForm.touched.email && SubscribeForm.errors.email ? (
                  <div className="text-red-500 lg:text-[16px] text-[8px]">
                    {SubscribeForm.errors.email}
                  </div>
                ) : null}
                {SubscriptionText !== "" && SubscriptionText !== "You are already subscribed!" ? (
                  <div className="text-green-500 font-medium lg:text-[16px] text-[8px]">
                    {SubscriptionText}
                  </div>
                ) : (
                  !SubscribeForm.touched.email &&
                  SubscriptionText == "You are already subscribed!" && (
                    <div className="text-red-500 font-medium lg:text-[16px] text-[8px]">
                      {props?.locale == props?.lang
                        ? "الإيميل مشترك"
                        : "You are already subscribed!"}
                    </div>
                  )
                )}
              </form>
            </div>
          </div>
          {/*
//Section3 only for  large Display */}
          <div className="lg:block col-span-1 hidden ">
            <h2 className="text-[#F2F2F2] lg:text-[18px] text-[9px] font-semibold">
              {props?.fields?.Title?.value}
            </h2>
            <div className="disclaimer w-full  mt-1">
              <p className="text-[#a6a5a5] text-[7px] md:text-[16px]">
                {props?.fields?.Disclaimer?.value}
              </p>
            </div>
            <form className="w-full" onSubmit={SubscribeForm.handleSubmit}>
              <div className="border-[#F2F2F2] border p-1 w-full flex lg:mt-3 mt-1">
                <input
                  id="email"
                  disabled={Disabled}
                  autoComplete="off"
                  name="email"
                  type="email"
                  onChange={SubscribeForm.handleChange}
                  onBlur={SubscribeForm.handleBlur}
                  value={SubscribeForm.values.email}
                  placeholder={props?.fields?.EmailPlaceholder?.value}
                  className={`bg-transparent text-white   ${
                    props?.locale == "ar" ? "mr-3" : "ml-3"
                  } text-[8px]   lg:text-[16px] w-full`}
                />

                <button
                  disabled={Disabled}
                  type="submit"
                  className="w-fit h-full lg:text-[16px] text-[8px] text-[142836] bg-white text-brand-50 lg:p-3 p-2"
                >
                  {!loading && <span>{props?.fields?.SubmitBtnText?.value}</span>}
                  {loading && (
                    <svg
                      aria-hidden="true"
                      className="inline w-6 h-6 animate-spin fill-brand-800"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill"
                      />
                    </svg>
                  )}
                </button>
              </div>
              {SubscribeForm.touched.email && SubscribeForm.errors.email ? (
                <div className="text-red-500 font-medium lg:text-[16px] text-[8px]">
                  {SubscribeForm.errors.email}
                </div>
              ) : null}
              {SubscriptionText !== "" && SubscriptionText !== "You are already subscribed!" ? (
                <div className="text-green-500 font-medium lg:text-[16px] text-[8px]">
                  {SubscriptionText}
                </div>
              ) : (
                !SubscribeForm.touched.email &&
                SubscriptionText == "You are already subscribed!" && (
                  <div className="text-red-500 font-medium lg:text-[16px] text-[8px]">
                    {props?.locale == props?.lang ? "الإيميل مشترك" : "You are already subscribed!"}
                  </div>
                )
              )}
            </form>
          </div>
        </div>

        {/* //Bottom Section */}
        <div className="w-full h-[1px] bg-[#A8A8A8] opacity-40 my-5"></div>

        <div className="flex flex-row justify-between">
          <div className="text-[#F2F2F2] lg:text-[16px] text-[8px]">
            {props?.fields?.Stamp?.value}
          </div>
          <div className="flex flex-row lg:gap-8 gap-3   ">
            {props?.fields?.SocialIcons?.length > 0 &&
              props?.fields?.SocialIcons?.map((socialLinks: any, index: number) => {
                return (
                  <span key={index} className="lg:w-6 lg:h-6 w-2 h-2 relative cursor-pointer">
                    <Link
                      href={socialLinks?.fields?.LinkUrl?.value.href.replace(
                        process?.env?.NEXT_PUBLIC_SITECORE_API_HOST,
                        ""
                      )}
                      passHref
                    >
                      <a target={socialLinks?.fields?.LinkUrl?.value?.target}>
                        <Image
                          src={socialLinks?.fields?.Icon?.value?.src}
                          alt={
                            (socialLinks?.fields?.Icon?.value?.alt ?? "").trim() ||
                            (socialLinks?.fields?.LinkUrl?.value?.text ?? "").trim() ||
                            "Social media"
                          }
                          layout="responsive"
                          className="absolute"
                          width={24}
                          height={24}
                        />
                      </a>
                    </Link>
                  </span>
                );
              })}
          </div>
          <div className="flex flex-row lg:gap-8 gap-2    justify-end">
            {props?.fields?.BottomSectionLinks?.length > 0 &&
              RenderLinks(props?.fields?.BottomSectionLinks)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default withDatasourceCheck()<FooterNavigationProps>(FooterNavigation);
